/**
 * select
 */

// Module dependencies
import 'protons';

// Module styles
import './_select.scss';

// Module template
import './_select.twig';

import { MDCSelect } from '@material/select';

/**
 * Components may need to run clean-up tasks if they are removed from DOM.
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Pertinent settings
 */
// eslint-disable-next-line no-unused-vars
export function disable($context, settings) {}

/**
 * Each component has a chance to run when its enable function is called. It is
 * given a piece of DOM ($context) and a settings object. We destructure our
 * component key off the settings object and provide an empty object fallback.
 * Incoming settings override default settings via Object.assign().
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Settings object
 */
export function enable() {}

export default enable;

// forEach method, could be shipped as part of an Object Literal/Module
const forEach = (array, callback, scope) => {
  for (let i = 0; i < array.length; i += 1) {
    callback.call(scope, i, array[i]);
  }
};

/* eslint-disable */
var textFields = document.querySelectorAll('.mdc-select');
forEach(textFields, function (index, value) {
  new MDCSelect(value);
});
/* eslint-enable */
